import axios from 'axios'
import {ID, QUERIES} from '../../../../../../_metronic/helpers'
import {Admission} from './_models'

const API_URL = process.env.REACT_APP_API_V2_URL + '/' + QUERIES.ADMISSIONS_LIST

const createAdmission = (admission: Admission): Promise<Admission | undefined> =>
  axios.post(API_URL, admission)

const updateAdmission = (admission: Admission): Promise<Admission | undefined> =>
  axios.patch(`${API_URL}/${admission.id}`, admission)

const admitStudent = (admission: Admission): Promise<Admission | undefined> =>
  axios.patch(`${API_URL}/admit/${admission.id}`, admission)

const deleteAdmission = (admissionId: ID): Promise<void> =>
  axios.delete(`${API_URL}/${admissionId}`)

export {deleteAdmission, createAdmission, updateAdmission, admitStudent}
